var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import "external-svg-loader";
import { injectIntl } from "react-intl";
import { ApplicationContext } from "../../../ApplicationContext";
/**
 *
 */
var AssetIcon = /** @class */ (function (_super) {
    __extends(AssetIcon, _super);
    /**
     *
     */
    function AssetIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            assetModel: _this.props.assetModel,
            iconSource: _this.props.src,
            fillColor: _this.props.color,
            width: _this.props.width,
            height: _this.props.height,
        };
        return _this;
    }
    AssetIcon.prototype.componentDidMount = function () {
        var assetIconNameToIconUrlDictionary = this.context.assetIconNameToIconUrlDictionary;
        var _a = this.state, iconSource = _a.iconSource, fillColor = _a.fillColor;
        var assetModel = this.props.assetModel;
        if (iconSource == null) {
            this.setState({ iconSource: assetIconNameToIconUrlDictionary.get(assetModel.properties.iconName) });
        }
        if (fillColor == null) {
            this.setState({ fillColor: assetModel.iconColor });
        }
    };
    AssetIcon.prototype.render = function () {
        var _a = this.props, src = _a.src, defaultSrc = _a.defaultSrc, color = _a.color, width = _a.width, height = _a.height, assetModel = _a.assetModel, style = _a.style, className = _a.className;
        var assetIconNameToIconUrlDictionary = this.context.assetIconNameToIconUrlDictionary;
        var iconSource = src !== null && src !== void 0 ? src : ((assetModel === null || assetModel === void 0 ? void 0 : assetModel.iconName) ? assetIconNameToIconUrlDictionary.get(assetModel === null || assetModel === void 0 ? void 0 : assetModel.iconName) : defaultSrc);
        var fillColor = color !== null && color !== void 0 ? color : assetModel === null || assetModel === void 0 ? void 0 : assetModel.iconColor;
        return (React.createElement("div", { className: className, style: { textAlign: "center" } }, iconSource &&
            React.createElement("svg", { style: style, onClick: this.props.onClick, "data-src": iconSource, fill: fillColor.hex(), stroke: fillColor.hex(), width: width, height: height })));
    };
    return AssetIcon;
}(React.Component));
AssetIcon.contextType = ApplicationContext;
export default injectIntl(AssetIcon);
